import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.pos');
import { OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-pos',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.pos/view.scss */
:host {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

* {
  box-sizing: border-box;
}

button, [role=button], .clickable {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.08);
  touch-action: manipulation;
  transition: transform 120ms ease, background-color 120ms ease, opacity 120ms ease;
}
button:active, [role=button]:active, .clickable:active {
  opacity: 0.85;
}

.login-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #1a1a2e;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-box {
  width: 420px;
  background: #253447;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  overflow: hidden;
}

.login-header {
  padding: 32px 32px 20px;
  text-align: center;
}

.login-logo {
  width: 48px;
  height: 48px;
  margin: 0 auto 12px;
  background: rgba(74, 158, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-logo svg {
  width: 28px;
  height: 28px;
  stroke: #4a9eff;
}

.login-title {
  font-size: 20px;
  font-weight: 700;
  color: #e8ecf1;
  margin: 0;
}

.login-body {
  padding: 0 32px 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-field {
  padding: 12px 16px;
  border-radius: 10px;
  border: 2px solid #3a4f66;
  background: #1e2a3a;
  cursor: pointer;
  transition: all 150ms;
}
.login-field.active {
  border-color: #4a9eff;
  background: rgba(74, 158, 255, 0.06);
}

.login-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #8899aa;
  margin-bottom: 8px;
  letter-spacing: 0.3px;
}

.login-input-row {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.login-digit {
  width: 48px;
  height: 52px;
  border-radius: 8px;
  border: 1px solid #3a4f66;
  background: #253447;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
  color: #e8ecf1;
  transition: all 150ms;
}
.login-digit.filled {
  border-color: #4a9eff;
  background: rgba(74, 158, 255, 0.1);
}
.login-digit.current {
  border-color: #4a9eff;
  box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.25);
}
.login-digit .cursor {
  color: #4a9eff;
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
}
.login-error {
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #ff3b30;
  padding: 4px 0;
}

.login-keypad {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lkp-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}

.lkp-btn {
  height: 48px;
  border-radius: 8px;
  border: 1px solid #3a4f66;
  background: #2d3e52;
  color: #e8ecf1;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 100ms;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}
.lkp-btn:hover {
  background: #3a4f66;
}
.lkp-btn:active {
  transform: scale(0.94);
}
.lkp-btn.lkp-c {
  background: #ff9500;
  border-color: #ff9500;
  color: #fff;
}
.lkp-btn.lkp-c:hover {
  opacity: 0.85;
}
.lkp-btn.lkp-del {
  background: #ff3b30;
  border-color: #ff3b30;
  color: #fff;
}
.lkp-btn.lkp-del:hover {
  opacity: 0.85;
}

.lkp-login {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  border: none;
  background: #4a9eff;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 150ms;
}
.lkp-login:hover:not(:disabled) {
  background: #3a8eef;
}
.lkp-login:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.pos-layout {
  --pos-bg: #f0f2f5;
  --pos-panel: #ffffff;
  --pos-card: #f7f8fa;
  --pos-card-strong: #eef2f7;
  --pos-border: #e2e5ea;
  --pos-text: #1a1a2e;
  --pos-text-dim: #6b7280;
  --pos-accent: #3b82f6;
  --pos-accent-hover: #2563eb;
  --pos-green: #22c55e;
  --pos-orange: #f59e0b;
  --pos-red: #ef4444;
  --pos-yellow: #eab308;
  --pos-cyan: #06b6d4;
  --pos-radius: 8px;
  --pos-radius-sm: 6px;
  --pos-field-height: 36px;
  --pos-control-height: 36px;
  --pos-input-bg: #f0f2f5;
  --pos-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  --pos-shadow-soft: 0 8px 24px rgba(15, 23, 42, 0.08);
  --pos-table-header: #f0f2f5;
  --pos-hover: rgba(59, 130, 246, 0.06);
  --pos-selected: rgba(59, 130, 246, 0.12);
  --pos-modal-backdrop: rgba(0, 0, 0, 0.3);
  --pos-keypad-display: #e8eaef;
  --pos-success-bg: rgba(34, 197, 94, 0.12);
  --pos-warning-bg: rgba(245, 158, 11, 0.14);
  --pos-danger-bg: rgba(239, 68, 68, 0.12);
  --pos-info-bg: rgba(59, 130, 246, 0.12);
  display: flex;
  flex-direction: row;
  height: 100%;
  background: var(--pos-bg);
  color: var(--pos-text);
  font-family: "SUIT", -apple-system, BlinkMacSystemFont, sans-serif;
  position: relative;
}

.pos-layout.theme-dark {
  --pos-bg: #1e2a3a;
  --pos-panel: #253447;
  --pos-card: #2d3e52;
  --pos-card-strong: #344861;
  --pos-border: #3a4f66;
  --pos-text: #e8ecf1;
  --pos-text-dim: #8899aa;
  --pos-accent: #4a9eff;
  --pos-accent-hover: #3a8eef;
  --pos-green: #34c759;
  --pos-orange: #ff9500;
  --pos-red: #ff3b30;
  --pos-yellow: #ffd43b;
  --pos-cyan: #35d0ed;
  --pos-input-bg: #1a2332;
  --pos-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  --pos-shadow-soft: 0 12px 32px rgba(0, 0, 0, 0.24);
  --pos-table-header: #1f3044;
  --pos-hover: rgba(74, 158, 255, 0.08);
  --pos-selected: rgba(74, 158, 255, 0.18);
  --pos-modal-backdrop: rgba(0, 0, 0, 0.6);
  --pos-keypad-display: #1a2332;
  --pos-success-bg: rgba(52, 199, 89, 0.14);
  --pos-warning-bg: rgba(255, 149, 0, 0.16);
  --pos-danger-bg: rgba(255, 59, 48, 0.14);
  --pos-info-bg: rgba(74, 158, 255, 0.16);
}

.pos-content {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

::ng-deep .num-input.keypad-active {
  border-color: var(--pos-accent) !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.25) !important;
  outline: none;
}

.pos-right-sidebar {
  width: 220px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: var(--pos-panel);
  border-left: 1px solid var(--pos-border);
  overflow: hidden;
}

.pos-menu-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  border-bottom: 1px solid var(--pos-border);
}

.slide-arrow {
  flex-shrink: 0;
  width: 100%;
  height: 28px;
  border: none;
  background: var(--pos-card);
  color: var(--pos-text-dim);
  font-size: 11px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 120ms;
}
.slide-arrow:hover {
  background: var(--pos-border);
  color: var(--pos-text);
}
.slide-arrow.arrow-up {
  border-bottom: 1px solid var(--pos-border);
}
.slide-arrow.arrow-down {
  border-top: 1px solid var(--pos-border);
}

.menu-viewport {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 6px;
}
.menu-viewport::-webkit-scrollbar {
  width: 3px;
}
.menu-viewport::-webkit-scrollbar-thumb {
  background: var(--pos-border);
  border-radius: 3px;
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
}

.pos-menu-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 6px;
  border-radius: 8px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  cursor: pointer;
  transition: all 150ms;
  user-select: none;
  min-height: 64px;
}
.pos-menu-btn:hover {
  background: var(--pos-accent);
  color: #fff;
  border-color: var(--pos-accent);
  transform: scale(1.02);
}
.pos-menu-btn:hover .btn-icon ::ng-deep svg {
  stroke: #fff;
}
.pos-menu-btn:active {
  transform: scale(0.97);
}
.pos-menu-btn .btn-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pos-menu-btn .btn-icon ::ng-deep svg {
  width: 22px;
  height: 22px;
  stroke: var(--pos-accent);
  transition: stroke 150ms;
}
.pos-menu-btn .btn-label {
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
  word-break: keep-all;
}

.pos-keypad-section {
  flex-shrink: 0;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.kp-display-area {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.kp-label {
  font-size: 10px;
  font-weight: 600;
  color: var(--pos-accent);
  letter-spacing: 0.3px;
  line-height: 1;
  margin-bottom: 2px;
}

.kp-display {
  width: 100%;
  background: var(--pos-keypad-display);
  border: 1px solid var(--pos-border);
  border-radius: 6px;
  padding: 6px 10px;
  text-align: right;
  font-size: 18px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--pos-text);
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.kp-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
}

.kp-btn {
  height: 40px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 100ms;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.kp-btn:hover {
  background: var(--pos-border);
}
.kp-btn:active {
  transform: scale(0.93);
}

.kp-clear {
  background: var(--pos-orange);
  border-color: var(--pos-orange);
  color: #fff;
}
.kp-clear:hover {
  opacity: 0.85;
}

.kp-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
}

.kp-del {
  background: var(--pos-red);
  border-color: var(--pos-red);
  color: #fff;
}
.kp-del:hover {
  opacity: 0.85;
}

.kp-enter {
  background: var(--pos-accent);
  border-color: var(--pos-accent);
  color: #fff;
  font-size: 12px;
}
.kp-enter:hover {
  background: var(--pos-accent-hover);
}

.theme-toggle {
  position: fixed;
  bottom: 16px;
  right: 232px;
  z-index: 900;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--pos-border);
  background: var(--pos-panel);
  color: var(--pos-text);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  transition: all 150ms;
  padding: 0;
}
.theme-toggle svg {
  width: 16px;
  height: 16px;
}
.theme-toggle:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.unclosed-warning-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.unclosed-warning-box {
  width: 420px;
  background: var(--pos-panel, #ffffff);
  border-radius: 16px;
  padding: 32px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.unclosed-warning-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  background: rgba(245, 158, 11, 0.12);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.unclosed-warning-icon svg {
  width: 28px;
  height: 28px;
  stroke: #f59e0b;
}

.unclosed-warning-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--pos-text, #1a1a2e);
  margin: 0 0 16px;
}

.unclosed-warning-msg {
  font-size: 14px;
  line-height: 1.6;
  color: var(--pos-text-dim, #6b7280);
  margin-bottom: 24px;
}
.unclosed-warning-msg strong {
  color: #f59e0b;
  font-weight: 700;
}
.unclosed-warning-msg p {
  margin: 0;
}

.unclosed-warning-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.unclosed-btn-outline {
  padding: 10px 24px;
  border-radius: 8px;
  border: 1px solid var(--pos-border, #e2e5ea);
  background: transparent;
  color: var(--pos-text-dim, #6b7280);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms;
}
.unclosed-btn-outline:hover {
  background: var(--pos-card, #f7f8fa);
}

.unclosed-btn-primary {
  padding: 10px 24px;
  border-radius: 8px;
  border: none;
  background: #f59e0b;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms;
}
.unclosed-btn-primary:hover {
  background: #d97706;
}`],
})
export class LayoutPosComponent implements OnInit, OnDestroy {
    public keypadValue: string = '';
    public theme: string = 'light';
    public showKeypad: boolean = true;
    public showMenuPanel: boolean = false;
    public showRightSidebar: boolean = true;
    public isPublicCustomerRoute: boolean = false;
    public activeLabel: string = '';
    public menuButtons: any[] = [];

    @ViewChild('menuViewport') menuViewport: ElementRef;

    private routerSub: any;
    private activeInput: HTMLInputElement | null = null;
    private focusInHandler: any;
    private focusOutHandler: any;
    private forceLogoutHandler: any;
    private menuConfigs: { [key: string]: any[] } = {};

    // ─── 로그인 모달 ───
    public isLoggedIn = false;
    public loginId = '';
    public loginPw = '';
    public loginField: 'id' | 'pw' = 'id';
    public loginError = '';

    // ─── 미마감 경고 모달 ───
    public showUnclosedWarning = false;
    public unclosedDate = '';

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( Router)         public router: Router,@Inject( DomSanitizer)         private sanitizer: DomSanitizer,    ) {
        this.initMenuConfigs();
    }

    private initMenuConfigs() {
        this.menuConfigs = {
            '/pos/sales': [
                { label: '메뉴관리', action: 'navigate', path: '/pos/sales/menu', svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16"/><path d="M4 12h16"/><path d="M4 18h10"/><circle cx="20" cy="18" r="2"/><path d="M20 14v2"/></svg>' },
                { label: '단체', action: 'event', event: 'group', svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>' },
                { label: '영수증 관리', action: 'navigate', path: '/pos/sales/receipt', svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 2v20l3-2 3 2 3-2 3 2 3-2 3 2V2l-3 2-3-2-3 2-3-2-3 2-3-2z"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="16" x2="13" y2="16"/></svg>' },
                { label: '주문서 조회', action: 'event', event: 'orderSearch', svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>' },
                { label: '직전영수증', action: 'event', event: 'lastReceipt', svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/><path d="M12 7v5l3 3"/></svg>' },
                { label: '재출력', action: 'event', event: 'reprint', svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>' },
                { label: '판매현황', action: 'navigate', path: '/pos/sales/status', svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>' },
                { label: '대기접수', action: 'event', event: 'waitList', svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>' },
                { label: '예약관리', action: 'event', event: 'reservation', svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><path d="M8 14h.01"/><path d="M12 14h.01"/><path d="M16 14h.01"/><path d="M8 18h.01"/><path d="M12 18h.01"/></svg>' },
                { label: '웹정보', action: 'event', event: 'webInfo', svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>' },
            ],
            '/pos/business': this.textButtons([
                '공지사항', '마감정산', '준비금등록', '시재점검',
                '사원근태', '마감취소', '중간정산', '시재입출금',
                '외상입금', '판매원변경', '상품권판매', '기사출금',
                '매출 I/F', '전자상품권',
            ]),
            '/pos/revenue': this.textButtons([
                '분류별 매출현황', '상품별 매출현황', '결제수단별 매출현황',
                '할인구분별 매출현황', '월별 매출현황', '정산현황',
                '시간대별 매출현황', '영수증별 매출현황', '상품별 주문 취소 현황',
                '코너별 매출현황', '시재 입출금 현황', '테이블그룹 매출현황',
            ]),
            '/pos/orders': this.textButtons([
                '발주등록', '발주현황', '수주등록', '수주현황',
                '입고등록', '출고등록', '재고조회', '거래처관리',
            ]),
            '/pos/settings': this.textButtons([
                '포스별 환경설정', '보안리더기 무결성점검', '자료보관(백업)',
                '원격제어', '포스데이터관리', '매출자료수신',
                '마스터수신설정', '단말기인증', '시스템로그전송',
                '매출자료전송', 'KT CID설정',
            ]),
        };
    }

    private textButtons(labels: string[]): any[] {
        return labels.map(label => ({ label, action: 'event', event: label }));
    }

    public async ngOnInit() {
        await this.service.init(this);
        const saved = localStorage.getItem('pos-theme');
        this.theme = saved || 'light';
        this.checkRoute(this.router.url);

        // 로그인 상태 확인 (서버 세션 기반)
        if (this.isPublicCustomerRoute) {
            this.isLoggedIn = false;
        } else {
            const sessionRes = await wiz.call("check_session");
            if (sessionRes.code === 200 && sessionRes.data?.staff) {
                this.isLoggedIn = true;
                localStorage.setItem('pos-auth', JSON.stringify({
                    loggedIn: true,
                    id: sessionRes.data.staff.id,
                    name: sessionRes.data.staff.name,
                    role: sessionRes.data.staff.role,
                }));
                await this.checkUnclosedBusinessDay();
            } else {
                this.isLoggedIn = false;
                localStorage.removeItem('pos-auth');
            }
        }

        this.routerSub = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.checkRoute(event.url);
                this.clearActiveInput();
                this.ref.detectChanges();
            }
        });

        this.focusInHandler = (e: FocusEvent) => {
            const target = e.target as HTMLElement;
            if (target && target.tagName === 'INPUT' && target.classList.contains('num-input') && target.closest('.pos-content')) {
                const input = target as HTMLInputElement;
                this.activeInput = input;
                this.activeInput.classList.add('keypad-active');
                this.keypadValue = input.value;
                this.activeLabel = input.getAttribute('data-label') || '';
                this.ref.detectChanges();
            }
        };

        this.focusOutHandler = (e: FocusEvent) => {
            const related = e.relatedTarget as HTMLElement;
            // 키패드 영역이나 사이드바 클릭 시 포커스 유지
            if (related && (related.closest('.pos-right-sidebar') || related.closest('.keypad-area'))) return;
            // mousedown 지연으로 인한 포커스 유실 방지: 50ms 후 체크
            const target = e.target as HTMLElement;
            if (target && target.classList.contains('num-input')) {
                setTimeout(() => {
                    const active = document.activeElement as HTMLElement;
                    if (active && (active.closest('.pos-right-sidebar') || active.closest('.keypad-area'))) return;
                    target.classList.remove('keypad-active');
                    this.clearActiveInput();
                    this.ref.detectChanges();
                }, 80);
            }
        };

        document.addEventListener('focusin', this.focusInHandler, true);
        document.addEventListener('focusout', this.focusOutHandler, true);

        this.forceLogoutHandler = () => { this.doLogout(); };
        document.addEventListener('pos-force-logout', this.forceLogoutHandler);

        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        document.removeEventListener('focusin', this.focusInHandler, true);
        document.removeEventListener('focusout', this.focusOutHandler, true);
        if (this.forceLogoutHandler) document.removeEventListener('pos-force-logout', this.forceLogoutHandler);
    }

    private clearActiveInput() {
        if (this.activeInput) this.activeInput.classList.remove('keypad-active');
        this.activeInput = null;
        this.keypadValue = '';
        this.activeLabel = '';
    }

    private checkRoute(url: string) {
        const base = url.split('?')[0];
        this.isPublicCustomerRoute = base === '/pos/customer';

        const noKeypad = ['/pos', '/pos/sales/receipt', '/pos/customer'];
        this.showKeypad = !noKeypad.includes(base);

        const config = this.menuConfigs[base];
        if (config) {
            this.menuButtons = config.map((btn: any) => ({
                ...btn,
                safeSvg: btn.svg ? this.sanitizer.bypassSecurityTrustHtml(btn.svg) : undefined,
            }));
            this.showMenuPanel = true;
        } else {
            this.menuButtons = [];
            this.showMenuPanel = false;
        }

        this.showRightSidebar = !this.isPublicCustomerRoute && (this.showKeypad || this.showMenuPanel);
    }

    public toggleTheme() {
        this.theme = this.theme === 'light' ? 'dark' : 'light';
        localStorage.setItem('pos-theme', this.theme);
        this.ref.detectChanges();
    }

    onKey(key: string) {
        if (this.activeInput && document.contains(this.activeInput)) {
            const input = this.activeInput;
            if (key === 'C') { input.value = ''; }
            else if (key === 'DEL') { input.value = input.value.slice(0, -1); }
            else if (key === 'ENTER') { input.blur(); this.clearActiveInput(); this.ref.detectChanges(); return; }
            else { input.value += key; }
            input.dispatchEvent(new Event('input', { bubbles: true }));
            this.keypadValue = input.value;
        } else {
            if (key === 'C') { this.keypadValue = ''; }
            else if (key === 'DEL') { this.keypadValue = this.keypadValue.slice(0, -1); }
            else if (key === 'ENTER') { }
            else { this.keypadValue += key; }
        }
        this.ref.detectChanges();
    }

    public onMenuBtnClick(btn: any) {
        if (btn.action === 'navigate' && btn.path) {
            this.service.href(btn.path);
        } else if (btn.action === 'event' && btn.event) {
            document.dispatchEvent(new CustomEvent('pos-menu-action', { detail: { action: btn.event } }));
        }
    }

    public menuScrollUp() {
        if (this.menuViewport) this.menuViewport.nativeElement.scrollBy({ top: -120, behavior: 'smooth' });
    }

    public menuScrollDown() {
        if (this.menuViewport) this.menuViewport.nativeElement.scrollBy({ top: 120, behavior: 'smooth' });
    }

    // ═══════ 미마감 경고 체크 ═══════
    private getTodayStr(): string {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    }

    private async checkUnclosedBusinessDay() {
        let res = await wiz.call("get_business_day");
        if (res.code !== 200) return;
        const bd = res.data?.data;
        if (!bd) return;

        const today = this.getTodayStr();
        // 이전 날짜가 개점되어 있으나 마감되지 않은 경우
        if (bd.date && bd.date !== today && bd.opened && !bd.closed) {
            this.unclosedDate = bd.date;
            this.showUnclosedWarning = true;
        }
    }

    public async closeUnclosedWarning() {
        this.showUnclosedWarning = false;
        await this.service.render();
    }

    public async goToClosing() {
        this.showUnclosedWarning = false;
        localStorage.setItem('pos-auto-section', 'closing');
        this.service.href('/pos/business');
        await this.service.render();
    }

    // ═══════ 로그인 모달 ═══════
    public async selectLoginField(field: 'id' | 'pw') {
        this.loginField = field;
        this.loginError = '';
        await this.service.render();
    }

    public async loginOnKey(key: string) {
        this.loginError = '';
        const current = this.loginField === 'id' ? this.loginId : this.loginPw;
        let updated = current;

        if (key === 'C') {
            updated = '';
        } else if (key === 'DEL') {
            updated = current.slice(0, -1);
        } else if (key === 'ENTER') {
            await this.doLogin();
            return;
        } else {
            if (current.length < 4) {
                updated = current + key;
            }
        }

        if (this.loginField === 'id') {
            this.loginId = updated;
        } else {
            this.loginPw = updated;
        }
        await this.service.render();
    }

    public async doLogin() {
        if (this.loginId.length !== 4) {
            this.loginError = '아이디는 4자리 숫자를 입력하세요.';
            await this.service.render();
            return;
        }
        if (this.loginPw.length !== 4) {
            this.loginError = '비밀번호는 4자리 숫자를 입력하세요.';
            await this.service.render();
            return;
        }

        let res = await wiz.call("login", { id: this.loginId, pw: this.loginPw });
        if (res.code !== 200) {
            this.loginError = res.data?.message || '아이디 또는 비밀번호가 일치하지 않습니다.';
            await this.service.render();
            return;
        }

        const staff = res.data.staff;
        this.isLoggedIn = true;
        localStorage.setItem('pos-auth', JSON.stringify({
            loggedIn: true,
            id: staff.id,
            name: staff.name,
            role: staff.role,
            loginTime: new Date().toISOString(),
        }));

        this.loginId = '';
        this.loginPw = '';
        this.loginField = 'id';
        this.loginError = '';

        // 로그인 후 미마감 체크
        await this.checkUnclosedBusinessDay();
        await this.service.render();
    }

    public async doLogout() {
        await wiz.call("logout");
        this.isLoggedIn = false;
        localStorage.removeItem('pos-auth');
        localStorage.removeItem('pos-business-day');
        this.loginId = '';
        this.loginPw = '';
        this.loginField = 'id';
        this.loginError = '';
        this.showUnclosedWarning = false;
        await this.service.render();
    }
}

export default LayoutPosComponent;